import { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { toast } from "sonner";
import { GoogleSignInButton, AuthDivider } from "@/components/GoogleSignInButton";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [busy, setBusy] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (password.length < 6) { toast.error("Password must be ≥ 6 chars"); return; }
    setBusy(true);
    const res = await register(name, email, password);
    setBusy(false);
    if (res.ok) {
      toast.success("Ledger opened — we've sent a verification email");
      navigate(params.get("next") || "/app");
    } else {
      toast.error(res.error || "Could not register");
    }
  };

  return (
    <div className="min-h-screen bg-[#F7F5F0] flex items-center justify-center p-8">
      <form onSubmit={submit} className="w-full max-w-md fade-in" data-testid="register-form">
        <span className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#6C7565]">Open a ledger</span>
        <h2 className="font-serif text-4xl lg:text-5xl mt-2 mb-4 tracking-tight">A new chapter begins.</h2>
        <p className="text-sm text-[#A67C00] mb-10 flex items-center gap-2" data-testid="register-trial-note">
          Includes a 7-day free Premium trial — AI assistant, voice logging & insights. No card required.
        </p>

        <label className="block mb-6">
          <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">Name</span>
          <input
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            data-testid="register-name-input"
            className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00]"
          />
        </label>
        <label className="block mb-6">
          <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">Email</span>
          <input
            type="email"
            required
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            data-testid="register-email-input"
            className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00] num"
          />
        </label>
        <label className="block mb-10">
          <span className="font-mono text-[10px] tracking-widest uppercase text-[#6C7565] block mb-2">Password</span>
          <input
            type="password"
            required
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            data-testid="register-password-input"
            className="w-full bg-transparent border-0 border-b border-[#1A1F16] py-2 text-lg focus:outline-none focus:border-[#A67C00]"
          />
        </label>

        <button
          type="submit"
          disabled={busy}
          data-testid="register-submit-btn"
          className="w-full bg-[#1A1F16] text-[#F7F5F0] py-4 uppercase tracking-[0.25em] text-xs hover:bg-[#2C3628] disabled:opacity-50"
        >
          {busy ? "Opening…" : "Open ledger"}
        </button>

        <AuthDivider />

        <GoogleSignInButton />

        <p className="mt-8 text-sm text-[#6C7565]">
          Already on record?{" "}
          <Link to="/login" className="text-[#1A1F16] underline underline-offset-4 hover:text-[#A67C00]" data-testid="register-to-login-link">
            Sign back in →
          </Link>
        </p>
      </form>
    </div>
  );
}
